import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/bootstrap4-light-blue/theme.css";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./assets/styles/index.scss";

ReactDOM.render(<App />, document.getElementById("root"));
